import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const uploadResultImages = async (formData, token) => {
  return await axios.post(`${API_BASE_URL}/result/upload-result-images`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getResultImages = async (data, token) => {
  return await axios.post(`${API_BASE_URL}/result`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};

export const updateStatusImage = async (id, active, token) => {
  return await axios.put(`${API_BASE_URL}/result/update-status/${id}`, {active}, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};